/* istanbul ignore file */
import { FormControlLabel, Radio, RadioGroup, SelectChangeEvent, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProductFileData } from '../mapSrcToProductFiles';
import { FlexRow, Label } from '../styles';
import { ProductFile } from '../Uploader';

type FileTypeRadioGroupProps = Readonly<{
  productFile: ProductFileData | ProductFile;
  disabled?: boolean;
  onChange?: (event: SelectChangeEvent<unknown>) => void;
}>;

export function FileTypeRadioGroup({ productFile, onChange, disabled }: FileTypeRadioGroupProps) {
  const { t } = useTranslation('uploads');

  // Until we support selecting upload type, we don't show the form
  return null;

  return (
    <div>
      <FlexRow>
        <LabelWithDisabled disabled={disabled}>What type of file is this?</LabelWithDisabled>
      </FlexRow>
      <FlexRow>
        <RadioGroup row value={productFile.type ?? ''} onChange={onChange}>
          <FormControlLabel disabled={disabled} value="bom" control={<Radio />} label={t('bomData')} />
          <FormControlLabel disabled={disabled} value="pricing" control={<Radio />} label={t('pricingDocument')} />
          <FormControlLabel
            disabled={disabled}
            value="other"
            control={<Radio />}
            label={t('otherAddIntoTheDescription')}
          />
        </RadioGroup>
      </FlexRow>
    </div>
  );
}

const shouldForwardProp = (prop: string) => prop !== 'disabled';

const LabelWithDisabled = styled(Label, { shouldForwardProp })<{ disabled?: boolean }>`
  color: ${({ disabled, theme }) => (disabled ? theme.palette.grey[500] : theme.palette.grey[900])};
`;
